import { RejestrFiltrowanyRequest } from '../../wspolne/rejestrFiltrowanyRequest';
import { KolumnaDoRaportu } from '../arkuszSpisu/kolumnaDoRaportu';
import { UruchomFiltrPorownywaniaDanychModel } from './uruchomFiltrPorownywaniaDanychModel';

export class WygenerujArkuszPorownaniaDanychModel {
  lokalizacja: string;
  przewodniczacyZespolu: string;
  czlonekZespolu: string;
  klient: string;
  przedstawicielKlienta: string;
  spisRozpoczetoData: string;
  spisRozpoczetoGodzina: string;
  spisZakonczonoData: string;
  spisZakonczonoGodzina: string;
  uwagi: string;
  kolumny: Array<KolumnaDoRaportu> = new Array();
  czyDrukowacMpkLokalizacji: boolean;
  filtry: RejestrFiltrowanyRequest<UruchomFiltrPorownywaniaDanychModel>;
  uwzglednijTylkoPozycjeZeSpisu: boolean;
}
